import React, { Component } from "react";
import { Button, Form, Icon, Input } from "antd";
import "./style.scss";

class LoginPage extends Component {
  state = {
    username: "",
    password: ""
  };

  render() {
    const { loading, error } = this.props;
    const { username, password } = this.state;
    return (
      <div className="login-page">
        <div className="login-panel">
          <div className="login-brand">Logan</div>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <Form.Item validateStatus={error ? "error" : ""} help={error || ""}>
              <Input
                autoFocus
                size="large"
                prefix={<Icon type="user" />}
                placeholder="用户名"
                value={username}
                onChange={this.handleUsernameChange}
              />
            </Form.Item>
            <Form.Item>
              <Input.Password
                size="large"
                prefix={<Icon type="lock" />}
                placeholder="密码"
                value={password}
                onChange={this.handlePasswordChange}
              />
            </Form.Item>
            <Button
              block
              size="large"
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={!username || !password}
            >
              登录
            </Button>
          </Form>
        </div>
      </div>
    );
  }

  handleUsernameChange = event => {
    this.setState({
      username: event.target.value
    });
  };

  handlePasswordChange = event => {
    this.setState({
      password: event.target.value
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { username, password } = this.state;
    this.props.onLogin(username, password);
  };
}

export default LoginPage;
